<template>
  <div>
    <base-container has-title
                    title="">
      <div class="text-xs-center  mt-default">
        <validation-observer ref="observerIdn">
          <v-container grid-list-md>
            <sub-content-qa class="align-center justify-center">
              <b-text-field placeholder=""
                  v-model="idnCard"
                  outline
                  :vname="idnLabel"
                  vid="idnCard_input"
                  mode="lazy"
                  style="width:200px"
                  class=" mt-2 d-in-block"
                  maxlength="10"
                  :rules="idnRule"
                  v-mask="'XXXXXXXXXX'"
                  @input="cusIdnHandler"
                  @blur="idnCard = fullToHalf(idnCard)"></b-text-field>
            </sub-content-qa>
          </v-container>
        </validation-observer>
      </div>
    </base-container>
  </div>
</template>
<script>
import { halfFull } from '@/mixin'
import { createNamespacedHelpers } from 'vuex'
import {
  isNationalIdentificationNumberValid
} from 'taiwan-id-validator'
import { dateFormatString } from '@/utils'
const { mapActions } = createNamespacedHelpers('ins')
export default {
  name: 'idn-card-dialog',
  mixins: [halfFull],
  props: {
    transCode: String,
    compCode: String,
    nationalCode: String,
    tabStep: {
      type: String,
      default: ''
    },
    checkIdn: {
      type: String,
      default: ''
    },
    inputError: String,
    idnLabel: {
      type: String,
      default: '身分證/居留證號碼'
    },
    chkRemoteNativeYn: {
      type: Boolean,
      default: false
    },
    chkAgentIdno: String
  },
  data () {
    return {
      idnCard: null,
      innerInputError: null
    }
  },
  watch: {
    inputError (v) {
      if (v) {
        this.innerInputError = v
      }
    }
  },
  computed: {
    idnRule () {
      let rules = 'required|mixId|min:10'
      const { tabStep, checkIdn, innerInputError, chkRemoteNativeYn, idnCard, chkAgentIdno } = this
      // if (!nationalCode) {// 為空
      //   rules = `${rules}|twId`
      // } else if (nationalCode === 'TW') { // 中華民國國籍
      //   rules = `${rules}|twId`
      // } else { // 其他國籍(居留證驗證)
      //   rules = `${rules}|residentId`
      // }
      if (tabStep === 'n3') {// 法定代理人呼叫
        rules = `${rules}|isSameLegal:${checkIdn}`
      }

      if (innerInputError) {
        rules = `${rules}|showMsg:${innerInputError}`
      }

      if (chkRemoteNativeYn) {
        if (!isNationalIdentificationNumberValid(idnCard)) {
          rules = `${rules}|showMsg:身分證號碼有誤，遠距投保只限本國自然人，請確認!`
          return rules
        }
      }
      if (chkAgentIdno) {
        if (idnCard === chkAgentIdno) {
          rules = 'showMsg:遠距投保不得為自保件！'
          return rules
        }
      }

      return rules
    }
  },
  methods: {
    ...mapActions(['checkIdnCard', 'queryReleasePermit']),
    cusIdnHandler (v) {
      if (v) {
        this.idnCard = v.toUpperCase()
      }
    },
    saveHandler(needCheckCarry) {
      this.innerInputError = null
      this.$doValidate('observerIdn').then(isValid => {
        if (isValid) {
          let vm = this
          if (needCheckCarry) {
            const now = dateFormatString(new Date(), 'yyyy-MM-dd')
            this.queryReleasePermit({
              cusIdn: this.idnCard,
              status: ['A'],
              startDt: now,
              endDt: now
            }).then(r => {
              const result = r.data
              if (result.length > 0) {
                vm.checkIdnCard({
                idnCard: vm.idnCard,
                transCode: vm.transCode,
                compCode: vm.compCode
                }).then(r => { // 後續處理
                  if (r.data.status === 'E') {// 失敗
                    vm.$alert(r.data.message)
                  } else if(r.data.status === 'M') {// 複選
                    vm.$alert(r.data.message).then(() => {
                      vm.$emit('getCusData', r.data.cusData)
                    })
                  } else { // 成功
                    vm.$emit('getCusData', r.data.cusData)
                  }
                })
              } else {
                this.$alert('您輸入的身分證字號未在攜出申請有效名單內，無法發查客戶資料')
              }
            })
          } else {
            vm.checkIdnCard({
              idnCard: vm.idnCard,
              transCode: vm.transCode,
              compCode: vm.compCode
            }).then(r => { // 後續處理
              if (r.data.status === 'E') {// 失敗
                vm.$alert(r.data.message)
              } else if(r.data.status === 'M') {// 複選
                vm.$alert(r.data.message).then(() => {
                  vm.$emit('getCusData', r.data.cusData)
                })
              } else { // 成功
                vm.$emit('getCusData', r.data.cusData)
              }
            })
          }
        }
      })
    }
  }
}
</script>
